// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1w3xQ","box":"WorkspacesBox_box__3g5Xr","node":"WorkspacesBox_node__3hzZK"};